import { ShoppingCart } from "@mui/icons-material";
import About from "../pages/Website/Content/About";
import Contact from "../pages/Website/Content/Contact";
import Home from "../pages/Website/Content/Home";
import Products from "../pages/Website/Content/Products";

const NavBarLinks = [
    {
        path: '/',
        name: 'home',
        component: Home,
        internal: true
    }, {
        path: '/about',
        name: 'about',
        component: About,
        internal: true
    }, {
        path: '/products',
        name: 'products',
        component: Products,
        internal: true
    }, {
        path: '/contact',
        name: 'contact',
        component: Contact,
        internal: true
    }, {
        path: 'https://loja.sagasystems.com.br/',
        internal: false,
        name: 'store',
        component: null,
        icon: ShoppingCart
    }, 
];

export default NavBarLinks;

